import { Card } from '@/components/ui/card'
import { StatsCardBaseProps, StatsCardBase } from './StatsCardBase'
import { ReactNode } from 'react'

interface StatsCardDesktopProps extends StatsCardBaseProps {
  chart?: ReactNode
}

/**
 * Desktop version of StatsCard
 * Uses base logic but has desktop-specific UI with chart support
 */
export const StatsCardDesktop = ({
  icon,
  iconAlt,
  label,
  value,
  loading = false,
  chart,
  className = ''
}: StatsCardDesktopProps) => {
  const displayValue = StatsCardBase.getDisplayValue(value, loading)

  return (
    <Card variant="default" padding="none" className={`bg-white dark:bg-[#1c1c1c] border border-solid border-white dark:border-[#1c1c1c] relative h-[100px] pt-2 pb-2 pl-6 pr-7 ${className}`}>
      {/* Left side - Icon, Label, Value */}
      <div className="absolute left-6 top-4 flex flex-col justify-between h-[68px]">
        <div className="flex items-center gap-1.5">
          <img src={icon} alt={iconAlt} className="w-4 h-4 dark:[filter:brightness(0)_invert(1)_opacity(0.72)]" />
          <span 
            className="font-plus-jakarta font-medium text-[13px] leading-[18px] text-[rgba(45,41,35,0.72)] dark:text-[rgba(253,253,253,0.72)]"
            style={{fontFeatureSettings: '"liga" off, "clig" off'}}
          >
            {label}
          </span>
        </div>
        <span className="text-[28px] leading-[32px] text-[#2d2923] dark:text-[#FDFDFD] tracking-[-0.2px] font-medium" >
          {displayValue}
        </span>
      </div>
      
      {/* Right side - Chart (optional, desktop only) */}
      {chart && (
        <div className="absolute right-7 top-2 w-full max-w-[214px] h-[80px]">
          {chart}
        </div>
      )}
    </Card>
  )
}

